import { Component } from 'react';

import branch from 'client/core/branch';
import log from 'client/lib/log';

import momentIsLiveChatAvailable from 'common/util/momentIsLiveChatAvailable';

const debug = log.debug('sunroom:components:SrFrontChat');

@branch({
  frontChatId: ['env', 'FRONT_CHAT_ID'],
})
class SrFrontChat extends Component {
  componentDidMount() {
    this._initChat();
  }

  _initChat() {
    const chatAvailable = momentIsLiveChatAvailable();
    if (
      !process.browser ||
      !this.props.frontChatId ||
      typeof global.FrontChat !== 'function' ||
      !chatAvailable
    ) {
      debug('Front chat is not enabled');
      return;
    }

    global.FrontChat('init', {
      chatId: this.props.frontChatId,
      useDefaultLauncher: false,
    });

    global.FrontChat('onUnreadChange', () => {
      global.FrontChat('show');
    });
  }

  render() {
    return null;
  }
}

SrFrontChat.displayName = 'SrFrontChat';

export default SrFrontChat;
